/**
 * This class handles generaal kitchen functionality.
 */
class KitchenService {
    /**
     * @param {VuexService} vuexService
     */
    constructor(
        vuexService
    ) {
        this.vuexService = vuexService;
    }

    /**
     * @param {KitchenZone[]} selectedKitchenZones
     */
    setSelectedKitchenZones(selectedKitchenZones) {
        const store = this.vuexService.getStore();
        store.commit('kitchen/setSelectedKitchenZones', selectedKitchenZones);
    }
}

module.exports = KitchenService;
